<template>
  <div>
    <div v-if="refundList.length === 0" style="color: grey">暂无退款信息</div>
    <el-timeline v-else class="marginLeft10 marginTop10" :reverse="true">
      <el-timeline-item v-for="(activity, index) in refundList" :key="index" :timestamp="activity.trefTime">
        <div>
          {{ activity.zrefund | refundType }}
          <span class="marginLeft5">{{ activity.trefTime }}</span>
          &nbsp;
          <span class="marginLeft5">{{ activity.srefundReasonDesc }}</span>
        </div>
        <div>
          退款商品:
          <el-tooltip effect="dark" placement="top" :content="formattedGoodsInfo(activity.crefGoodsName, activity.nrefGoodsNum)">
            <span class="text-ellipsis">{{ formattedGoodsInfo(activity.crefGoodsName, activity.nrefGoodsNum) }}</span>
          </el-tooltip>
        </div>
        <div>
          退款金额:<span class="text-ellipsis">{{ activity.sapplyRefundUserAmount / 100 }}</span>
        </div>
        <div>
          退款原因:
          <el-tooltip effect="dark" placement="top" :content="activity.srefundReason">
            <span class="text-ellipsis">{{ activity.srefundReason }}</span>
          </el-tooltip>
        </div>
        <div>
          退款类型:
          <span class="text-ellipsis">{{ activity.nWhetherReturnGoods === 1 ? "退货退款" : "仅退款" }}</span>
        </div>
        <div>
          退款选择:
          <span class="text-ellipsis" style="color: red;">{{ activity.brefundAll === 0 ? "部分退款" : "全部退款" }}</span>
        </div>
        <div>
          图片附件:
          <el-image v-for="item in activity.imageUrls" :key="item" :src="item" :preview-src-list="activity.imageUrls" class="h100 w100" fit="fit"></el-image>
        </div>
        <el-button v-if="activity.zrefund !== 20 && activity.zrefund !== 50" v-hasPermi="['order:orderProcessing:refund']" @click="handleReject(activity.sid, activity.platType)" size="mini">拒绝</el-button>
        <el-button v-if="activity.zrefund !== 20 && activity.zrefund !== 50" v-hasPermi="['order:orderProcessing:pass']" @click="handleGreen(activity.sid)" size="mini">同意</el-button>
      </el-timeline-item>
    </el-timeline>
    <el-dialog :close-on-click-modal="false" title="取消原因" :visible.sync="dialogVisible" width="450px" append-to-body>
      <div @click="refundOption = 1">
        <el-card shadow="hover" :class="{ 'is-selected': refundOption === 1, ' box-shadow': refundOption === 1, marginBottom10: 1 }" body-style="background-color: white;">订单不符合取消退款条件，正常履约</el-card>
      </div>
      <div @click="refundOption = 2">
        <el-card shadow="hover" :class="{ 'is-selected': refundOption === 2, ' box-shadow': refundOption === 2, marginBottom10: 1 }" body-style="background-color: white;">
          同意顾客取消退款请求，线下处理顾客订单取消退款<br />
          <span style="color: #b5b4bf; font-size: 12px">注意：线下退款当前系统只支持整单退款退货。顾客若只是部分退货退款，请采用线上退货退款方式。</span>
        </el-card>
      </div>
      <div class="alignItemsCenter marginBottom10">
        <div class="marginRight10" style="color: red;">取消原因(必选):</div><br>
        <div class="radio-container">
          <el-radio v-for="item in reasonOptions" :key="item.id" v-model="reasonCode" :label="item.id">{{ item.label }}</el-radio><br>
        </div>
        <div v-if="reasonCode === -1 || reasonCode === 7001">
          <el-input v-model="reason" type="textarea" :rows="3" resize="none"></el-input>
        </div>
      </div>
      <el-row type="flex" justify="end">
        <el-button type="primary" plain @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 认</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "OrderRefund",
  filters: {
    refundType(value) {
      // 0初始化，10申请，20拒绝，30仲裁，40关闭，50成功，60失败
      if (value === 0) {
        return "初始化";
      } else if (value === 10) {
        return "申请";
      } else if (value === 20) {
        return "拒绝";
      } else if (value === 30) {
        return "仲裁";
      } else if (value === 40) {
        return "关闭";
      } else if (value === 50) {
        return "成功";
      } else if (value === 60) {
        return "失败";
      }
    },
  },
  props: {
    orderId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      refundList: [],
      reasonOptions: [],
      platType: null,
      reasonCode: -1,
      refundId: null,
      refundOption: 1,
      reason: "正在配送途中,请耐心等待",
    };
  },
  mounted() {
    this.handleInit();
  },
  methods: {
    handleInit() {
      let url = `${this.baseUrls.mqrefund}/queryList`;
      this.topsAjax.get(url, { orderId: this.orderId }).then((response) => {
        this.refundList = response;
      });
    },
    formattedGoodsInfo(goodsName, goodsNum) {
      if (goodsName === undefined || goodsNum === undefined) return "";
      const names = goodsName.split(",");
      const nums = goodsNum.split(",");
      let str = names.map((name, index) => `${name}(${nums[index]})`).join(", ");
      return str;
    },
    handleReject(refundId, platType) {
      this.refundId = refundId;
      this.platType = platType;
      if (this.platType === 1) {
        this.reasonOptions = [
          { id: 12, label: "已和用户电话沟通" },
          { id: 13, label: "商品已开始制作" },
          { id: 14, label: "商品已经打包完成" },
          { id: 15, label: "商品正在配送中" },
          { id: 16, label: "商品无质量问题" },
          { id: 17, label: "商品没有缺货少货问题" },
          { id: 18, label: "商品打包完好" },
          { id: 1, label: "已和用户沟通一致不退货" },
          { id: 2, label: "商品发出时完好" },
          { id: 3, label: "商品没有问题，买家未举证" },
          { id: 4, label: "商品没有问题，买家举证无效" },
          { id: 5, label: "商品已经影响二次销售" },
          { id: 6, label: "申请时间已经超过售后服务时限" },
          { id: 7, label: "不支持买家主观原因的退换货" },
          { id: 8, label: "已和用户沟通一致不退款" },
          { id: 9, label: "收到货物有破损" },
          { id: 10, label: "未收到货物" },
          { id: 11, label: "买家未按要求寄出货物" },
          { id: -1, label: "其他" },
        ];
        this.reasonCode = -1;
      } else {
        this.reasonOptions = [
          { id: 7019, label: "双方协商一致不再取消订单" },
          { id: 7020, label: "商品已经备货完成" },
          { id: 7021, label: "商品已送出" },
          { id: 7802, label: "商品发出时完好" },
          { id: 7803, label: "用户未举证/举证无效" },
          { id: 7804, label: "商品影响二次销售" },
          { id: 7805, label: "商品不符合7天无理由退款" },
          { id: 7302, label: "未收到退货(仅退货单支持)" },
          { id: 7001, label: "其他原因" },
        ];
        this.reasonCode = 7001;
      }
      this.dialogVisible = true;
    },
    handleConfirm() {
      this.topsAjax.post(`${this.baseUrls.mqrefund}/refund`, { refundId: this.refundId, refundOption: this.refundOption, reasonCode: this.reasonCode, reason: this.reason }).then(() => {
        this.$message.warning("拒绝退款，订单已返回");
        this.$emit("handleConfirm");
        this.dialogVisible = false;
      });
    },
    //取消订单
    handleGreen(refundId) {
      this.topsAjax.get(`${this.baseUrls.mqrefund}/getByROrder`, { refundId }).then((response) => {
        let str = "";
        let warning = "";
        if (response.brefundAll === 0) {
          if (response.zstate === 1) {
            str = "订单在拣货，该操作需要修改订单并重新拣货！确定要执行该操作么？";
            warning = "警告！订单终止拣货，拣货单已删除！";
          } else if (response.zstate === 2) {
            str = "订单已拣货，该操作需要修改订单、拣货单，确定要执行该操作么？";
            warning = "警告！订单拣货单已取消，请知悉！";
          } else if (response.zstate === 3) {
            str = "订单已出货，订单将挂起并转移到待处理状态！确定要执行该操作么？";
            warning = "警告！订单配送单已取消，请知悉！";
          }
        } else {
          if (response.zstate === 1) {
            str = "订单在拣货，订单将被关闭！确定要执行改操作么？";
            warning = "警告！订单终止拣货，拣货单已删除！";
          } else if (response.zstate === 2) {
            str = "订单已拣货，系统将取消拣货单、配送单，并将关闭订单！确定要执行改操作么？";
            warning = "警告！订单拣货单已取消，请知悉！";
          } else if (response.zstate === 3) {
            str = "订单已拣货，系统将取消拣货单、配送单，并将关闭订单！确定要执行改操作么？";
            warning = "警告！订单配送单已取消，请知悉！";
          }
        }

        this.$confirm(str, "同意取消/退款提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.topsAjax.post(`${this.baseUrls.mqrefund}/agree`, { refundId }).then(() => {
            this.$message.success("已同意退款");
            this.$emit("handleConfirm");
          });
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.radio-container {
  display: flex;
  flex-wrap: wrap; /* 允许项目换行 */
}
.radio-container .el-radio {
  margin-right: 20px; /* 根据需要调整间距 */
  margin-bottom: 10px; /* 根据需要调整间距 */
}
</style>
